import { useFormik } from "formik"
import React, { useEffect, useState } from "react"
import { Col, FloatingLabel, Form, Row, Spinner } from "react-bootstrap"
import { toast } from "react-toastify"
import * as Yup from "yup"
import ModalComponent from "../../../components/Modal"
import { admin } from "../../../config/apiEndpoints"
import axiosProvider from "../../../lib/AxiosProvider"
import { handleOnBlur, handleOnchange } from "../../../lib/GlobalMethods"
import { _numberRegex_ } from "../../../lib/Regex"

const AddEditConvenienceFee = ({
  isUpdateConvenienceFees,
  setIsUpdateConvenienceFees,
  show,
  fetchData,
  handleClose,
}) => {
  const [loading, setLoading] = useState(false)

  const validationSchema = Yup.object({
    convenience_fee: Yup.string().required("Convenience Fee is required"),
  })

  const handleSubmit = async (values, { resetForm }) => {
    try {
      setLoading(true)
      const response = await axiosProvider({
        method: "PATCH",
        endpoint: admin.updateConvenienceFee,
        data: values,
      })

      if (response?.data?.code === 201 || response?.data?.code === 200) {
        toast.success(response.data.message)
        setLoading(false)
        fetchData()
        handleClose()
        setIsUpdateConvenienceFees(false)
        resetForm()
      } else {
        setLoading(false)
        throw { message: response?.data?.message }
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message)
    }
  }

  const formik = useFormik({
    initialValues: {
      convenience_fee: isUpdateConvenienceFees?.convenience_fee,
    },
    validationSchema,
    onSubmit: handleSubmit,
    enableReinitialize: true,
  })

  const { errors, values, touched, setFieldValue, resetForm } = formik

  return (
    <>
      <ModalComponent
        show={show}
        modalsize={"md"}
        backdrop="static"
        animationFade={true}
        onHide={() => {
          handleClose()
          resetForm()
        }}
        loading={loading}
        modeltitle={"Update Convenience Fees"}
        submitname={
          loading ? (
            <Spinner size="sm" animation="border" variant="light" />
          ) : (
            "Update"
          )
        }
        btnclosetext="Cancel"
        handleSubmit={formik.handleSubmit}
        children={
          <Form
            noValidate
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                e.preventDefault()
              }
            }}
          >
            <Row xs={"auto"}>
              <Col xs={12}>
                <FloatingLabel
                  controlId="convenience_fee"
                  label={
                    <>
                      Convenience Fee <span className="required_star">*</span>
                    </>
                  }
                  className="mb-3"
                >
                  <Form.Control
                    autoComplete="false"
                    type="text"
                    name="convenience_fee"
                    placeholder=""
                    className="mb-n1"
                    maxLength={10}
                    value={values.convenience_fee}
                    onChange={(e) => handleOnchange(e, _numberRegex_, formik)}
                    onBlur={(e) => handleOnBlur(e, formik)}
                    isInvalid={
                      touched.convenience_fee && !!errors.convenience_fee
                    }
                    isValid={touched.convenience_fee && !errors.convenience_fee}
                  />
                  <Form.Control.Feedback type="invalid">
                    {errors.convenience_fee}
                  </Form.Control.Feedback>
                </FloatingLabel>
              </Col>
            </Row>
          </Form>
        }
      />
    </>
  )
}

export default AddEditConvenienceFee
